/**
 * B2BDeliveryDelayCell — édition inline du délai de livraison par ligne.
 *
 * Extrait de l'ex-`B2BTab.jsx` (Phase A++) sans modification de comportement.
 * Sauvegarde via PATCH `/api/b2b/orders/{orderId}/items/{itemIndex}/delivery-delay`
 * sur `onBlur` (ou Enter) avec datalist de presets pré-remplis.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API, auth, DELAY_PRESETS } from './B2BConstants';

export const DeliveryDelayCell = ({ orderId, itemIndex, value, canWrite, onChanged }) => {
  const [draft, setDraft] = useState(value || '48h après validation');
  const [saving, setSaving] = useState(false);
  const initial = React.useRef(value || '48h après validation');

  useEffect(() => {
    setDraft(value || '48h après validation');
    initial.current = value || '48h après validation';
  }, [value]);

  const save = async () => {
    if (saving) return;
    const trimmed = (draft || '').trim() || '48h après validation';
    if (trimmed === initial.current) return;
    setSaving(true);
    try {
      await axios.put(
        `${API}/b2b/orders/${orderId}/items/${itemIndex}/delivery-delay`,
        { delivery_delay: trimmed },
        { headers: auth() },
      );
      toast.success('Délai mis à jour');
      initial.current = trimmed;
      onChanged?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur mise à jour délai');
      setDraft(initial.current);
    } finally {
      setSaving(false);
    }
  };

  if (!canWrite) {
    return <span className="text-xs text-zinc-700">{value || '48h après validation'}</span>;
  }
  const dlid = `delay-presets-${orderId}-${itemIndex}`;
  return (
    <div className="flex items-center gap-1">
      <input
        list={dlid}
        className="flex-1 h-7 px-1.5 text-xs border border-zinc-200 rounded bg-white focus:border-emerald-400 focus:outline-none"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={save}
        onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
        disabled={saving}
        maxLength={200}
        data-testid={`delivery-delay-input-${itemIndex}`}
      />
      <datalist id={dlid}>
        {DELAY_PRESETS.map((p) => <option key={p} value={p} />)}
      </datalist>
      {saving && <span className="text-[10px] text-zinc-400">…</span>}
      {!saving && draft !== '48h après validation' && (
        <span
          className="inline-block w-1.5 h-1.5 rounded-full bg-amber-400"
          title="Délai personnalisé (différent du défaut 48h)"
        />
      )}
    </div>
  );
};
